import type { APIReferenceAttributes } from '@ardoq/api-types';
import {
  toLoadedModelElement,
  type ModelElement,
} from 'modelElements/modelElementIds';
import type { ComponentsState } from 'streams/components/components$';
import type { StreamCollection } from 'streams/utils/streamUtils';
import type { PresentationModelElementDoubleClickedPayload } from './actions';

export const toPresentationNode = (
  { elementModelId, ...ids }: PresentationModelElementDoubleClickedPayload,
  components: ComponentsState,
  references: StreamCollection<APIReferenceAttributes>
): ModelElement | null => {
  if (elementModelId) {
    return { entityType: 'component', id: elementModelId };
  }
  return toLoadedModelElement(ids, components, references);
};
